import { ProductSwitcherProps } from '@pushpay/shell/lib/types/components/product-switcher/product-switcher';
import { ProductSwitcherRedirectValue } from '@pushpay/shell/lib/types/components/product-switcher/types';
import { ProductSwitcherViewModel } from '../loggedinweb-generated';

type UseProductSwitcherPropsArgs = ProductSwitcherViewModel & {
	hasMasAccess: boolean;
	isMasActive: boolean;
	organizationKey: string;
};

export function getProductSwitcherConfig({
	CcbTenantUrl,
	LaunchPadUrl,
	PushpayMarketingUrl,
	hasMasAccess,
	isMasActive,
	organizationKey,
}: UseProductSwitcherPropsArgs): ProductSwitcherProps {
	function buildRedirectUrl(value: ProductSwitcherRedirectValue) {
		const url = new URL(LaunchPadUrl);
		url.searchParams.set('redirect', encodeURIComponent(btoa(JSON.stringify(value))));
		return url.toString();
	}

	function getChmsProps(): ProductSwitcherProps['chmsProps'] {
		const label = 'ChMS';
		if (CcbTenantUrl) {
			return { access: 'hasAccess', label, url: buildRedirectUrl({ product: 'ccb', tenantUrl: CcbTenantUrl }) };
		}
		return { access: 'organizationNoProduct', label };
	}

	function getAppStudioProps(): ProductSwitcherProps['appStudioProps'] {
		const label = 'App Studio';
		if (!isMasActive) {
			return { access: 'organizationNoProduct', label };
		}
		if (!hasMasAccess) {
			return { access: 'noPermission', label };
		}
		return { access: 'hasAccess', label, url: buildRedirectUrl({ product: 'mas', organizationKey }) };
	}

	return {
		title: 'Switch to',
		tooltips: {
			noPermission: `Your organization has this product, but you'll need to request access from your organization's admin.`,
			organizationNoProduct: `Sorry, your organization doesn't have access to this product. Contact our team to learn more.`,
		},
		givingProps: { label: 'Giving', access: 'current' },
		chmsProps: getChmsProps(),
		appStudioProps: getAppStudioProps(),
		pushpayMarketing: { label: 'Pushpay.com', title: 'Pushpay website', url: PushpayMarketingUrl },
		learnMore: {
			label: 'Learn more',
			url: 'https://grow.pushpay.com/lp-dm-product-switcher.html?utm_medium=site&utm_source=pushpay&utm_content=dm-product-switcher&utm_campaign=product-switcher&utm_term=faith--all--all',
		},
	};
}
